module.exports = __webpack_public_path__ + "img/couples_14_V.fa0fa129.webp";